import React from 'react';
import BudgetAllocationWorkspace from './BudgetAllocationWorkspace';

/** 예산배정승인 */
export default function BudgetAllocApprove() {
  return <BudgetAllocationWorkspace screenMode="approve" />;
}
